<template>
  <v-layout row wrap class="mb-5">
    <v-flex xs12 class="text-xs-center">
      <v-container ma-0>
        <u
          ><h1 :class="'secondary--text'">
            {{ $t("screener.monetization.festival_pricing_plans") }}
          </h1></u
        >
      </v-container>
    </v-flex>
    <v-flex xs12 sm12>
      <v-container ma-0 grid-list-sm grid-list-md grid-list-lg>
        <v-layout v-if="tickets.length" row wrap>
          <v-flex v-for="(ticket, index) in tickets" :key="index" xs12 sm12 md3>
            <GroupTicket
              :ticket="ticket"
              :key="index"
              @onBuyTicket="initiateEnrollment"
            ></GroupTicket>
          </v-flex>
        </v-layout>

        <v-layout v-if="no_festival_pricing_plans" row wrap justify-center align-center>
          <v-flex xs12>
            <div class="my-5 text-xs-center">
              <div class="title secondary--text text--darken-1">
                {{ $t("screener.monetization.wait.message") }}
              </div>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-flex>
    <Enrollment :dialog.sync="dialog" :modeOfUse="DEFINES.ENROLLMENT_COMP.MODE_OF_USE.PASS" :pass="pricing"></Enrollment>
  </v-layout>
</template>

<script>
import DEFINES from "@/defines";
// import rules from "@/validation";
// import i18n from "@/i18n";
import { mapState, mapGetters } from "vuex";
// import moment from "moment";
// import { utcToTz } from "@/helper";

// Components
import GroupTicket from "@/components/monetization/GroupTicket";
import Enrollment from "@/components/company/Enrollment";


// data
const data = {
  dialog: false,
  pricing: null,
  no_festival_pricing_plans: false
};

const components = {
  GroupTicket,
  Enrollment
};

// Computed
const computed = {
  ...mapState({
    tickets: state => state.monetization.list,
    currentCompany: (state) => state.company.company,
  }),
  ...mapGetters("company", {
    timezone: "getSelectedCompanyTimezone"
  })
};

// Methods
const methods = {
  async getPricingListFromApi() {
    try {
      await this.$store.dispatch("monetization/listPricing");
      if(!this.tickets.length){
        this.no_festival_pricing_plans = true;
      }
    } catch (error) {
      this.$store.dispatch("app/showMessage", {
        message: error.message,
        color: this.DEFINES.ERROR_COLOR
      });
    }
  },
  initiateEnrollment(pricing) {
    this.pricing = pricing;
    this.dialog = true;
  }
};

export default {
  name: "GroupTicketList",
  data() {
    return data;
  },
  components: components,
  computed: computed,
  mounted() {
    this.getPricingListFromApi();
  },
  methods: methods
};
</script>
